import clsx from 'clsx';
import * as React from 'react';

export type FieldsetProps = React.ComponentPropsWithoutRef<'fieldset'>;

/**
 * A set of fields grouped together.
 */
export const Fieldset = React.forwardRef(function FormSection(
    props: FieldsetProps,
    ref: React.ForwardedRef<HTMLFieldSetElement>
) {
    return (
        <fieldset
            ref={ref}
            // We may support horizontal later
            aria-orientation="vertical"
            {...props}
            className={clsx('flex flex-col gap-5', props.className)}
        />
    );
});

export type LegendProps = React.ComponentPropsWithoutRef<'legend'>;

/**
 * A legend (descriptive label) for a fieldset.
 */
export const Legend = React.forwardRef(function Legend(
    props: LegendProps,
    ref: React.ForwardedRef<HTMLLegendElement>
) {
    return (
        <legend ref={ref} {...props} className={clsx('text-ui-heading-small', props.className)} />
    );
});
